import { render } from "./CptDesc.vue?vue&type=template&id=f594d034&scoped=true"
import script from "./CptDesc.vue?vue&type=script&lang=js"
export * from "./CptDesc.vue?vue&type=script&lang=js"

import "./CptDesc.vue?vue&type=style&index=0&id=f594d034&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f594d034"]])

export default __exports__